import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../config';

export interface CreateRolloutInput {
  percentage: number;
  regions?: string[];
  customerIds?: string[];
  rolloutMode?: 'percentage' | 'customer' | 'both';
}

export function useCreateRollout() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ releaseId, data }: { releaseId: number; data: CreateRolloutInput }) => {
      return await api.post(`/api/v1/updates/admin/rollout/${releaseId}`, data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['releases'] });
      queryClient.invalidateQueries({ queryKey: ['rollouts'] });
    },
  });
}